import { Alert, Badge, Collapse, Descriptions, Drawer, Flex, Typography } from 'antd';
import PropTypes from 'prop-types';
import { getHarnessError, harnessDisplayStatuses } from '../utils/harness';

const HarnessMemberDrawer = ({ member, open, onClose, onClosed }) => {
  const status = harnessDisplayStatuses[member?.displayStatus];
  return (
    <Drawer
      title="成员详情"
      open={open}
      onClose={onClose}
      afterOpenChange={(visible) => {
        if (!visible) onClosed();
      }}
      size={560}
    >
      {!member ? (
        <Alert type="info" title="该成员已不在当前组织中" />
      ) : (
        <Flex vertical gap="large">
          <Descriptions
            column={1}
            items={[
              { key: 'name', label: '成员', children: member.memberName || '未命名成员' },
              { key: 'version', label: '当前版本', children: member.tag || '—' },
              {
                key: 'status',
                label: '运行状态',
                children: <Badge status={status?.status.toLowerCase()} text={status?.text} />,
              },
            ]}
          />
          {member.error && (
            <Alert
              type="error"
              showIcon
              title="运行异常"
              description={getHarnessError(member.error)}
            />
          )}
          <Collapse
            items={[
              {
                key: 'technical',
                label: '技术信息',
                children: (
                  <Descriptions
                    column={1}
                    items={[
                      { key: 'repository', label: '镜像仓库', children: member.repository || '—' },
                      {
                        key: 'id',
                        label: '实例标识',
                        children: (
                          <Typography.Text
                            aria-label="Harness 实例标识"
                            copyable={!!member.harnessId}
                          >
                            {member.harnessId || '—'}
                          </Typography.Text>
                        ),
                      },
                      {
                        key: 'digest',
                        label: '当前 Digest',
                        children: (
                          <Typography.Text
                            aria-label="Harness 实际 Digest"
                            copyable={!!member.digest}
                          >
                            {member.digest || '—'}
                          </Typography.Text>
                        ),
                      },
                      { key: 'raw', label: '底层状态', children: member.status || '—' },
                      { key: 'error', label: '错误码', children: member.error || '—' },
                    ]}
                  />
                ),
              },
            ]}
          />
        </Flex>
      )}
    </Drawer>
  );
};
HarnessMemberDrawer.propTypes = {
  member: PropTypes.shape({
    displayStatus: PropTypes.string,
    memberName: PropTypes.string,
    tag: PropTypes.string,
    error: PropTypes.string,
    repository: PropTypes.string,
    harnessId: PropTypes.string,
    digest: PropTypes.string,
    status: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
  onClosed: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
export default HarnessMemberDrawer;
